import { render, staticRenderFns } from "./BusinessCategoryManageItem.vue?vue&type=template&id=c1d382c6"
import script from "./BusinessCategoryManageItem.vue?vue&type=script&lang=js"
export * from "./BusinessCategoryManageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports